import AirDatepicker from 'air-datepicker';
import localeEn from 'air-datepicker/locale/en.js';
import { elements } from './elements.js';
import { hiddenClass, displayDateFormat, serverDateTimeFormat } from '../../../config.js';
import { updateForm } from './bindFormElements.js';
import { format, parse, isValid } from 'date-fns';

const prepareDateForServer = (date, hours, minutes) => {
    if (!date) return '';

    const parsed = parse(date, displayDateFormat, new Date());
    if (!isValid(parsed)) {
        return '';
    }

    parsed.setHours(hours);
    parsed.setMinutes(minutes);
    return format(parsed, serverDateTimeFormat);
}

const handleDateSelect = (clearButton, searchForm, date) => {
    if (date.formattedDate) {
        clearButton.classList.remove(hiddenClass);
    } else {
        clearButton.classList.add(hiddenClass);
    }

    updateForm(searchForm);
};

const handleClearButton = (field, clearButton, picker, searchForm) => {
    return () => {
        picker.clear();
        field.value = '';
        clearButton.classList.add(hiddenClass);
        updateForm(searchForm);
    };
};

const initializeDatePicker = (field, searchForm) => {
    if (!field) return;

    const clearButton = field.nextElementSibling;
    if (!clearButton) return;

    // The plugin offered both daysShort and daysMin, but statically set to daysMin and no config to use daysShort
    localeEn.default.daysMin = localeEn.default.daysShort;

    const picker = new AirDatepicker(field, {
        locale: localeEn.default,
        autoClose: true,
        dateFormat: displayDateFormat,
        onSelect: (date) => handleDateSelect(clearButton, searchForm, date)
    });

    clearButton.addEventListener('click', handleClearButton(field, clearButton, picker, searchForm));

    // Toggle clear button visibility based on field value
    if (!field.value) {
        clearButton.classList.add(hiddenClass);
    } else {
        clearButton.classList.remove(hiddenClass);
        const date = field.value;
        const parsed = parse(date, displayDateFormat, new Date());
        if (isValid(parsed)) {
            picker.selectDate(parsed);
        }
    }
};

export const initializeCalendarFields = () => {
    const { updatedAfterInput, updatedBeforeInput, searchForm } = elements;

    if (!searchForm) return;

    // Initialize datepicker on the date fields
    initializeDatePicker(updatedAfterInput, searchForm);
    initializeDatePicker(updatedBeforeInput, searchForm);
};

export const formDataParsing = {
    'updated-after': (value) => prepareDateForServer(value, 23, 59),
    'updated-before': (value) => prepareDateForServer(value, 0, 0),
}
